import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Py from './assets/Py.jpeg'
import Io from './assets/io.gif'
import Var from './assets/var.jpg'
import Loop from './assets/loop.jpeg'
import Lfc from './assets/lfc.jpg'
import Snk from './assets/Snk.png'
import List from './assets/list.jpg'
import RevList from './assets/RevList.png'
import SndList from './assets/sndList.jpg'
import SortList from './assets/SortList.png'
import Clone from './assets/Clone.webp'
import Tup from './assets/Tup.jpg'
import Tuplecube from './assets/Tuplecube.jpg'
import ClosePair from './assets/closepair.png'
import Pair from './assets/pair.png'
import Nested from './assets/nested.jpg'
import SortSecond from './assets/sortSecond.png'
import Sets from './assets/Sets.jpg'
import Dictionary from './assets/dictionary.jpg'
import Unique from './assets/unique.jpg'
import RemoveDic from './assets/removeDic.png'
import MissKey from './assets/missKey.jpg'
import mirChar from './assets/mirChar.jfif'
import CombChar from './assets/CombChar.jpg'
import Nque from './assets/nque.png'
import PrimePy from './assets/primePy.png'
import Oop from './assets/oop.jpeg'
import Com from './assets/com.jpg'
import Datahiding from './assets/datahidding.webp'
import Inheritance from './assets/inheritance.gif'
import Arrays from './assets/Array.png'
import Poly from './assets/poly.jpeg'
import ConstP from './assets/ConstP.png'
import DestructorP from './assets/destructorP.webp'
import Meta from './assets/Meta.jpg'
import Class from './assets/classAttribute.png'
import Exception from './assets/ExceptionHp.png'
import UserExcept from './assets/userExcept.png'
import CleanUp from './assets/cleanUp.jpg'
import TryExcept from './assets/tryExcept.png'
import Dq from './assets/Dq.png'
import Heap from './assets/heap.png'
import Djano from './assets/Django.png'
import NumPy from './assets/NumPy.png'
import SSC from './assets/SSC.jpg'
import Pandas from './assets/Pandas.png'
import Dataframe from './assets/Dataframe.jfif'
import Conversion from './assets/ConversionFunction.png'
import ML from './assets/ML.jpeg'
import Module from './assets/module.jpg'
import OsModule from './assets/osmodule.png'
import Calender from './assets/calendar.jpg'
import Import from './assets/import.jpg'
import Pm from './assets/P&m.jpg'
import Series from './assets/series.png'
import Alpha from './assets/alpha.jpg'
import Num from './assets/num.jfif'
import Data from './assets/Data.png'
import Str from './assets/str.jfif'
import StrRev from './assets/strRev.jpg'
import Plndrm from './assets/plndrm.png'
import Sub from './assets/sub.png'
import Rmz from './assets/rmz.jfif'
import Anal from './assets/Data-Aanalyst.jpeg'
const Python1 = () => {
    return (
        <div>
          <h1 style={{textAlign:'centre'}}>Topics to be Covered</h1>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Py}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Python Language Introduction</p>
      <NavLink to='/category/python/Introduction'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Io} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Input and Output</p>
      <NavLink to='/category/python/Input and Output'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Var} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Initializing a variable</p>
        <NavLink to='/category/python/varibles'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Loop} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Loops</p>
      <NavLink to='/category/python/loop'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Alpha}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Alphabet Pattern</p>
      <NavLink to='/category/python/Alphabet pattern'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Num} />
      </div>
    <div class="card_title title-white">
      <p >Number Pattern</p>
      <NavLink to='/category/python/Number pattern'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Data} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Data Types</p>
        <NavLink to='/category/python/Data types'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Str} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Strings</p>
      <NavLink to='/category/python/String'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Lfc}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Least Frequent Character in String</p>
      <NavLink to='/category/python/Least_String'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Snk} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Convert Snake case to Pascal case</p>
      <NavLink to='/category/python/Snake_Pascal'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={StrRev} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Reverse String</p>
        <NavLink to='/category/python/Reverse string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Plndrm} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Check Palindrome or not</p>
      <NavLink to='/category/python/Palindrome'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Sub}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Find Substring of a String</p>
      <NavLink to='/category/python/find  substring of a string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={List} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Lists</p>
      <NavLink to='/category/python/List'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={RevList} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Reversing a List</p>
        <NavLink to='/category/python/Reverse List'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={SndList} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>find second largest number in a list</p>
      <NavLink to='/category/python/Second largest'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={SortList}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Sort the values of first list using second list</p>
      <NavLink to='/category/python/Sort list'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Clone} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Cloning or Copying a list</p>
      <NavLink to='/category/python/Cloning'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Tup} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Tuples</p>
        <NavLink to='/category/python/Tuple'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Tuplecube} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Create a list of tuples from given list having number and its cube in each tuple</p>
      <NavLink to='/category/python/Python program to create a list of tuples from the given list having the number and its cube in each tuple'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={ClosePair}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Closest Pair to Kth index element in Tuple</p>
      <NavLink to='/category/python/Closest Pair to Kth index element in Tuple'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Pair} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>All pair combinations of 2 tuples</p>
      <NavLink to='/category/python/All pair combinations of 2 tuples'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Nested} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Convert Nested Tuple to Custom Key Dictionary</p>
        <NavLink to='/category/python/Convert Nested Tuple to Custom Key Dictionary'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={SortSecond} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Sort a list of tuples by second Item</p>
      <NavLink to='/category/python/program to sort a list of tuples by second Item'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Sets}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Sets</p>
      <NavLink to='/category/python/sets'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Dictionary} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Dicitonary</p>
      <NavLink to='/category/python/Dictionary'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Unique} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Extract Unique values dictionary values</p>
        <NavLink to='/category/python/ Extract Unique values dictionary values'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={RemoveDic} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Ways to remove a key from dictionary</p>
      <NavLink to='/category/python/ Ways to remove a key from dictionary'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={MissKey}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Handling missing keys in Python dictionaries</p>
      <NavLink to='/category/python//Handling missing keys in Python dictionaries'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={mirChar} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Python Dictionary to find mirror characters in a string</p>
      <NavLink to='/category/python/Python Dictionary to find mirror characters in a string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={CombChar} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Possible Words using given characters in Python</p>
        <NavLink to='/category/python/Possible Words using given characters in Python'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Arrays} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Array</p>
      <NavLink to='/category/python/Arrays in Python'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Nque}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>N-Queen Problem</p>
      <NavLink to='/category/python/N-Queen Problem in Python'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Rmz} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Rat in a maze</p>
      <NavLink to='/category/python/Rat in a maze'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={PrimePy} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>check Prime or not</p>
        <NavLink to='/category/python/Check Prime'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Oop} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>OOPS</p>
      <NavLink to='/category/python/Oops'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Com}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>class,object and member</p>
      <NavLink to='/category/python/Class object and member'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Datahiding} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Data hiding And object printing</p>
      <NavLink to='/category/python/Data hiding and print object'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Inheritance} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Inheritance</p>
        <NavLink to='/category/python/Inheritance'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Poly} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Polymorphism</p>
      <NavLink to='/category/python/Polymorphism'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={ConstP}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Constructor</p>
      <NavLink to='/category/python/Constructors'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={DestructorP} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Destructor</p>
      <NavLink to='/category/python/Destructors'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Meta} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Metaprogramming</p>
        <NavLink to='/category/python/Metaprogramming'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Class} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Class and instance attribute</p>
      <NavLink to='/category/python/Class and attributes'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Exception}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Exception handling</p>
      <NavLink to='/category/python/Exception'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={UserExcept} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>User Defined Exception</p>
      <NavLink to='/category/python/User Defined Exception'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={CleanUp} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>clean up action</p>
        <NavLink to='/category/python/Defining Clean Up Actions'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={TryExcept} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>try and except in Python</p>
      <NavLink to='/category/python/Python Try Except'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Dq}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>DeQueue</p>
      <NavLink to='/category/python/Dequeuq'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Heap} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Heap</p>
      <NavLink to='/category/python/Heap'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Djano} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Django</p>
        <NavLink to='/category/python/Django'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Anal} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Data Analysis</p>
      <NavLink to='/category/python/Data_analysis'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={NumPy}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Numpy</p>
      <NavLink to='/category/python/Numpy'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={SSC } />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Sorting, Searching and Counting</p>
      <NavLink to='/category/python/Sorting searching and counting'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Pandas} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Pandas</p>
        <NavLink to='/category/python/Pandas'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Series} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Python Pandas Series</p>
      <NavLink to='/category/python/Pandas series'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Dataframe}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Creating a Pandas DataFrame</p>
      <NavLink to='/category/python/creating data frame'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Conversion} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Conversion Functions in Pandas DataFrame</p>
      <NavLink to='/category/python/Conersion data frame'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={ML} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Machine Learning</p>
        <NavLink to='/category/python/Machine learning'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Module} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>Introduction of Modules</p>
      <NavLink to='/category/python/Modules'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={OsModule}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>OS module</p>
      <NavLink to='/category/python/OS Module'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Calender} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:"1rem"}}>Calendar Module</p>
      <NavLink to='/category/python/Calender module'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Import} />
    </div>
    <div class="card_title">
        <p style={{fontSize:"1rem"}}>Import module</p>
        <NavLink to='/category/python/Import modules'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Pm} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:"1rem"}}>MongoDB and Python</p>
      <NavLink to='/category/python/Mongo_Db'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
        </div>
    )
}

export default Python1
